import { axiosGet } from '@gsretail/gssm-util'

const API_URL = import.meta.env.VITE_API_URL

/**
 * @description: HttpMenuAuthRetrieveUserInfo (유저정보조회)
 */
export const HttpMenuAuthRetrieveUserInfo = () => {
  return axiosGet({
    url: API_URL + '/comm/api/cm/sy/authmng/menu-auth/retrieve-user-info'
  })
}
